import { getSessionAuthentication, baseUrl } from '../common/Api';

interface FetchOptions {
    method: string;
    headers: Record<string, string>;
    body?: string;
}

function getHeaders(): Record<string, string> {
    const auth = getSessionAuthentication();
    return {
        'Content-Type': 'application/json',
        'Authorization': auth.token,
        'x-cleverapps-tenant': auth.tenantStringIdentifier,
    };
}

async function legacyFetch<T>(path: string, options?: Partial<FetchOptions>): Promise<T> {
    const response = await fetch(baseUrl + path, {
        method: options?.method ?? 'GET',
        headers: getHeaders(),
        body: options?.body,
    });
    if (!response.ok) {
        const text = await response.text();
        let message = `API error: ${response.status} ${response.statusText}`;
        try {
            const parsed = JSON.parse(text);
            if (parsed?.message) message = parsed.message;
        } catch { /* ignore */ }
        throw new Error(message);
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
}

export interface MainGroup {
    id: number;
    mainGroupCode: string;
    mainGroupDescription: string;
}

export interface Intrastat {
    id: number;
    code: string;
    internalDescription: string;
}

export interface SubCategory {
    id: number;
    subCategoryCode: string;
    subCategoryName: string;
    mainGroups: MainGroup[];
    intrastats: Intrastat[];
}

export async function getSubCategory(id: number): Promise<SubCategory> {
    return legacyFetch<SubCategory>(`subcategories/${id}`);
}

export async function saveSubCategory(sc: SubCategory): Promise<SubCategory> {
    return legacyFetch<SubCategory>('subcategories', {
        method: 'POST',
        body: JSON.stringify(sc),
    });
}

export async function getMainGroups(): Promise<MainGroup[]> {
    return legacyFetch<MainGroup[]>('subcategories/maingroups');
}

export async function getIntrastats(): Promise<Intrastat[]> {
    return legacyFetch<Intrastat[]>('subcategories/intrastats');
}
